module.exports = __webpack_public_path__ + "static/media/BG_50.727bea1f.png";